@use "../../styles/breakpoint.module.scss" as *;

.contentWrapper {
    padding: 0 var(--spacer-48) var(--spacer-48) var(--spacer-48);

    @media ($below-mobile) {
        // Overriding Flexihero values to match design requirements
        flex-direction: column !important;
    }

    & ~ div {
        // Overriding default alignment values of Split component
        // to match design requirements
        align-self: flex-start !important;
    }
}
